var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.339,
    height: 11.437,
    viewBox: "0 0 11.339 11.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176798",
    "data-name": "Group 176798",
    transform: "translate(3207.848 -3745)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163629",
    "data-name": "Rectangle 163629",
    width: 6.746,
    height: 5.996,
    transform: "translate(-3205.551 3747.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176797",
    "data-name": "Group 176797",
    transform: "translate(-3207.848 3745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176796",
    "data-name": "Group 176796",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104175",
    "data-name": "Path 104175",
    d: "M166.735,519.227a.95.95,0,0,0-.192-.659,1,1,0,0,0-.33-.274.951.951,0,0,1-.393-1.331.929.929,0,0,0-.068-1.061.949.949,0,0,1,.012-1.173.869.869,0,0,1,.193-.18.98.98,0,0,0,.428-.638,1.252,1.252,0,0,0-.018-.434.945.945,0,0,1,.74-1.051,1.232,1.232,0,0,0,.431-.148.961.961,0,0,0,.427-.594.937.937,0,0,1,.85-.708,1.12,1.12,0,0,1,.383.048.929.929,0,0,0,1.01-.327.908.908,0,0,1,.66-.323.959.959,0,0,1,.731.276.917.917,0,0,0,.562.235.943.943,0,0,0,.477-.089.951.951,0,0,1,1.274.531.923.923,0,0,0,.76.6c.089.014.179.007.269.024a.944.944,0,0,1,.769.844c.007.074,0,.147,0,.221a.913.913,0,0,0,.5.859.962.962,0,0,1,.539.742.9.9,0,0,1-.111.584.934.934,0,0,0,.057,1.079.973.973,0,0,1,.2.573.925.925,0,0,1-.239.638,2.593,2.593,0,0,1-.264.222.918.918,0,0,0-.32.917.942.942,0,0,1-.157.755.883.883,0,0,1-.589.378,1.02,1.02,0,0,0-.592.285.959.959,0,0,0-.244.438.932.932,0,0,1-.593.667.971.971,0,0,1-.631.012.939.939,0,0,0-1.024.32.926.926,0,0,1-.826.322.959.959,0,0,1-.548-.255.927.927,0,0,0-1.045-.165.954.954,0,0,1-1.279-.513.942.942,0,0,0-.758-.609c-.057-.009-.115-.011-.172-.015a.938.938,0,0,1-.878-.937C166.734,519.281,166.735,519.254,166.735,519.227Zm7.555-5.071a.44.44,0,0,0-.222-.37.435.435,0,0,0-.543.086l-3.393,3.392c-.093.093-.158.093-.252,0l-.436-.436c-.183-.183-.365-.369-.551-.549a.438.438,0,0,0-.6.639c.462.463.927.922,1.385,1.388a.45.45,0,0,0,.656,0c.7-.711,1.412-1.415,2.119-2.122l1.689-1.688A.476.476,0,0,0,174.29,514.155Z",
    transform: "translate(-165.555 -510.371)",
    fill: "#206eb6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.a52affd314273b9b287611cc5b05d745.svg";
export { ForwardRef as ReactComponent };